<template>
  <form class="pronostic">
    <Row>
      <ColumnUi md="3">
        <FormField
          name="model"
          title="model"
          tag="select"
          @getValue="handleModel"
          label="Modelo-dominio"
          :options="modelsOptions"
        />
      </ColumnUi>
      <ColumnUi md="6">
        <FormField
          name="variable"
          title="variable"
          tag="select"
          :disabled="variables.data.length == 0"
          @getValue="handleVariable"
          label="Variables"
          :options="variablesOptions.data"
        />
      </ColumnUi>
      <ColumnUi md="3">
        <FormField
          name="time"
          title="time"
          tag="select"
          :disabled="times.data.length == 0"
          @getValue="handleTime"
          label="Tiempo"
          :options="timesOptions.data"
        />
      </ColumnUi>
    </Row>
  </form>
  <div v-if="selectedTime.length > 0" class="pronostic__image">
    <img v-bind:src="selectedTime + '?v=' + currentDate" />
  </div>
  <div v-else></div>
  <p>
    La información mostrada en esta página es de carácter experimental y está
    orientada principalmente al grupo de investigadores del IGP y estudiantes
    que desarrollan investigaciones en ciencias de la atmósfera. Puede ser usada
    también por usuarios interesados en el comportamiento de la atmósfera en
    América del sur y el Perú a corto plazo (48 horas).
  </p>
</template>

<script>
import Row from "@/components/ui/atoms/Row";
import ColumnUi from "@/components/ui/atoms/ColumnUi";
import FormField from "@/components/ui/atoms/FormField";
import { model } from "@/model.json";
import { ref, reactive, readonly, watch } from "vue";

export default {
  components: {
    Row,
    ColumnUi,
    FormField
  },
  setup() {
    const models = readonly(model);
    const variables = reactive({ data: [] });
    const times = reactive({ data: [] });
    const currentDate = new Date();
    const selectedModel = ref("");
    const selectedVariable = ref("");
    const selectedTime = ref("");

    const modelsOptions = [];
    let variablesOptions = reactive({ data: [] });
    let timesOptions = reactive({ data: [] });

    for (const value in models) {
      modelsOptions.push({
        text: value,
        value
      });
    }

    const changeVariables = () => {
      variablesOptions.data = [];
      for (const value of variables.data) {
        variablesOptions.data.push({
          text: value,
          value
        });
      }
    };

    const changeTimes = () => {
      timesOptions.data = [];
      const keys = Object.keys(times.data);
      const values = Object.values(times.data);
      keys.forEach((time, index) => {
        timesOptions.data.push({
          text: values[index],
          value: time
        });
      });
    };

    const handleModel = value => {
      selectedModel.value = value;
      variables.data = Object.keys(models[value]);
      if (selectedTime.value.length > 0) {
        selectedTime.value = "";
      }
      if (selectedVariable.value.length > 0) {
        times.data = models[selectedModel.value][selectedVariable.value];
      }
    };
    const handleVariable = value => {
      selectedVariable.value = value;
      times.data = models[selectedModel.value][value];
    };
    const handleTime = value => {
      selectedTime.value = value;
    };

    watch(selectedModel, () => {
      changeVariables();
    });

    watch(selectedVariable, () => {
      changeTimes();
    });

    return {
      models,
      modelsOptions,
      variables,
      variablesOptions,
      times,
      timesOptions,
      selectedTime,
      currentDate,
      handleModel,
      handleVariable,
      handleTime
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.pronostic {
  margin-bottom: variables.$spacing;
  &__image {
    display: flex;
    justify-content: center;
    margin-bottom: variables.$spacing-s;
  }
}
</style>
